/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocations_EditInputs */

const en_admin_allocations_edit = /** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Allocation`)
};

const de_admin_allocations_edit = /** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisung bearbeiten`)
};

const es_admin_allocations_edit = /** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar asignación`)
};

const fr_admin_allocations_edit = /** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'attribution`)
};

const nl_admin_allocations_edit = /** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toewijzing bewerken`)
};

/** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */
const it_admin_allocations_edit = en_admin_allocations_edit;

/** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */
const pt_br2_admin_allocations_edit = en_admin_allocations_edit;

/** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */
const pl_admin_allocations_edit = en_admin_allocations_edit;

/** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */
const hu_admin_allocations_edit = en_admin_allocations_edit;

/** @type {(inputs: Admin_Allocations_EditInputs) => LocalizedString} */
const ro_admin_allocations_edit = en_admin_allocations_edit;

/**
* | output |
* | --- |
* | "Edit Allocation" |
*
* @param {Admin_Allocations_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocations_edit = /** @type {((inputs?: Admin_Allocations_EditInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocations_EditInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocations_edit(inputs)
	if (locale === "de") return de_admin_allocations_edit(inputs)
	if (locale === "es") return es_admin_allocations_edit(inputs)
	if (locale === "fr") return fr_admin_allocations_edit(inputs)
	if (locale === "nl") return nl_admin_allocations_edit(inputs)
	if (locale === "it") return it_admin_allocations_edit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocations_edit(inputs)
	if (locale === "pl") return pl_admin_allocations_edit(inputs)
	if (locale === "hu") return hu_admin_allocations_edit(inputs)
	return ro_admin_allocations_edit(inputs)
});
export { admin_allocations_edit as "admin.allocations.edit" }